import { Component, OnInit } from "@angular/core";
import { NzButtonSize } from "ng-zorro-antd/button";
import { AppService } from "src/app/shared/app.service";
import { Router } from "@angular/router";
import { NzMessageService } from "ng-zorro-antd/message";
import { DomSanitizer } from '@angular/platform-browser';
@Component({
  selector: "app-home",
  templateUrl: "./home.component.html",
  styleUrls: ["./home.component.css"],
})
export class HomeComponent implements OnInit {
  TotalItems: number
  Eventdata = [];
  images = [
    '/assets/images/banner/banner-03.jpg',
    '/assets/images/banner/banner-05.jpg',
  ]
  comments = [
    {
      name: 'Dr. Shahid Jameel',
      image: '/assets/images/Dr Shahid Jameel.png',
      comments: `The 10th year anniversary is a good time for reflection and launching a new vision. There are many gaps that we strive to fill in our quest for diversity, efficiency, equality, (good) outcomes and transparency in science, and the way it links to society both in a local as well as global sense.`,
      designation: `Ex-CEO, DBT/Wellcome Trust India Alliance `,
      date: '22 July 2020'
    },
    {
      name: 'Prof. Jeremy Farrar',
      image: '/assets/images/Prof. Jeremy Farrar.png',
      comments: `As an established and respected international partnership, we can do more than fund people with great ideas. We must push ourselves in our second decade to do more. We can use our focus on excellence, our experience, expertise and authority to influence the contexts in which ideas progress, and to make sure they can generate the maximum possible benefit for the largest number.`,
      designation: ` Director, The Wellcome Trust, UK`,
      date: '1 July 2020'
    },
    {
      name: 'Prof. K. VijayRaghavan',
      image: '/assets/images/Prof. K. VijayRaghavan.png',
      comments: `Foundational development of basic science leading to consequential effects on our society and economy is important. This message will be critical in the next phase of the India Alliance, as we try to strengthen the foundation and increase the footprint of biomedical science`,
      designation: `Former Principle Scientific Advisor to the Government of India`,
      date: '3 July 2020'
    },
    {
      name: 'Shri Ram Nath Kovind',
      image: '/assets/images/Ramnath Kovind.png',
      comments: `As it completes its first decade, this is an opportune moment for the India Alliance to draft its priorities for the next phase – to look ahead with even greater courage and go forth even more boldly. Just as the Alliance was started by not doing simply more of the same, you must now open a new path`,
      designation: `Former President of India`,
      date: '31 July 2020',
    },
    {
      name: 'Dr. Harsh Vardhan',
      image: '/assets/images/Dr Harshvardhan.png',
      comments: `Being a clinician, I understand the need to focus on biomedical research and integrate clinicians in the scientific research force to meet the global health challenges. I am glad to see the India Alliance, the partnership of DBT and Wellcome Trust, has tried to breach the gap between clinical practice and scientific research`,
      designation: `Former Union Minister for Science & Technology, Earth Sciences and Health & Family Welfare`,
      date: '3 July 2020'
    },
    {
      name: 'Dr. Renu Swarup',
      image: '/assets/images/Dr. Renu Swarup.png',
      comments: `Partnerships like the Wellcome Trust/DBT India Alliance are very important to build not only our research collaborations but also to help build capacity for our researchers and students. In 10 years, the India Alliance has become a benchmark for excellence in research.`,
      designation: `Former Secretary, Department of Biotechnology, Government of India`,
      date: '10 July 2020'
    },
    {
      name: 'Prof Mike Ferguson',
      image: '/assets/images/OrgImg4.png',
      comments: 'While DBT/Wellcome Trust India Alliance can, in terms of size and scope, only be a small component of a much larger Indian scientific firmament, it aspires to be catalytic and transformative one.',
      designation: `Deputy Chair, Wellcome Board of Governors`,
      date: '31 July 2020'
    },
  ]
  panelOpenState = false;
  size: NzButtonSize = "large";
  fellowsList = [];
  newsFeedData: any[];
  cardWidth: string;
  responsiveOptions: any;
  selectedComment = this.comments[3];
  bgImages = []
  bgUrl = this.bgImages[0]
  fadeIn = {
    '-webkit-animation': 'fade-in 1.2s cubic-bezier(0.390, 0.575, 0.565, 1.000) both',
    ' animation': 'fade-in 1.2s cubic-bezier(0.390, 0.575, 0.565, 1.000) both'
  }
  fadeOut = {
    ' -webkit-animation': 'fade-out 1s ease-out both',
    'animation': 'fade-out 1s ease-out both'
  }
  myCOmmentClass = {
    '-webkit-animation': 'fade-in 1.2s cubic-bezier(0.390, 0.575, 0.565, 1.000) both',
    'animation': 'fade-in 1.2s cubic-bezier(0.390, 0.575, 0.565, 1.000) both'
  }
  smallNews = []
  homePageNews = [];
  eventsList = [];
  deadLinesList = [];
  currentUrl: any;
  bannerHeight: any;
  labelsObj = {
    "The 10th year anniversary is a good time for reflection and launching a new vision. There are many gaps that we strive to fill in our quest for diversity, efficiency, equality, (good) outcomes and transparency in science, and the way it links to society both in a local as well as global sense.": "The 10th year anniversary is a good time for reflection and launching a new vision. There are many gaps that we strive to fill in our quest for diversity, efficiency, equality, (good) outcomes and transparency in science, and the way it links to society both in a local as well as global sense.",
    "As an established and respected international partnership, we can do more than fund people with great ideas. We must push ourselves in our second decade to do more. We can use our focus on excellence, our experience, expertise and authority to influence the contexts in which ideas progress, and to make sure they can generate the maximum possible benefit for the largest number": "As an established and respected international partnership, we can do more than fund people with great ideas. We must push ourselves in our second decade to do more. We can use our focus on excellence, our experience, expertise and authority to influence the contexts in which ideas progress, and to make sure they can generate the maximum possible benefit for the largest number",
    "Foundational development of basic science leading to consequential effects on our society and economy is important. This message will be critical in the next phase of the India Alliance, as we try to strengthen the foundation and increase the footprint of biomedical science": "Foundational development of basic science leading to consequential effects on our society and economy is important. This message will be critical in the next phase of the India Alliance, as we try to strengthen the foundation and increase the footprint of biomedical science",
    "As it completes its first decade, this is an opportune moment for the India Alliance to draft its priorities for the next phase – to look ahead with even greater courage and go forth even more boldly. Just as the Alliance was started by not doing simply more of the same, you must now open a new path": "As it completes its first decade, this is an opportune moment for the India Alliance to draft its priorities for the next phase – to look ahead with even greater courage and go forth even more boldly. Just as the Alliance was started by not doing simply more of the same, you must now open a new path",
    "Being a clinician, I understand the need to focus on biomedical research and integrate clinicians in the scientific research force to meet the global health challenges. I am glad to see the India Alliance, the partnership of DBT and Wellcome Trust, has tried to breach the gap between clinical practice and scientific research": "Being a clinician, I understand the need to focus on biomedical research and integrate clinicians in the scientific research force to meet the global health challenges. I am glad to see the India Alliance, the partnership of DBT and Wellcome Trust, has tried to breach the gap between clinical practice and scientific research",
    "Partnerships like the Wellcome Trust/DBT India Alliance are very important to build not only our research collaborations but also to help build capacity for our researchers and students. In 10 years, the India Alliance has become a benchmark for excellence in research.": "Partnerships like the Wellcome Trust/DBT India Alliance are very important to build not only our research collaborations but also to help build capacity for our researchers and students. In 10 years, the India Alliance has become a benchmark for excellence in research.",
    "While DBT/Wellcome Trust India Alliance can, in terms of size and scope, only be a small component of a much larger Indian scientific firmament, it aspires to be catalytic and transformative one.": "While DBT/Wellcome Trust India Alliance can, in terms of size and scope, only be a small component of a much larger Indian scientific firmament, it aspires to be catalytic and transformative one.",
    "As an established and respected international partnership, we can do more than fund people with great ideas. We must push ourselves in our second decade to do more. We can use our focus on excellence, our experience, expertise and authority to influence the contexts in which ideas progress, and to make sure they can generate the maximum possible benefit for the largest number.": "As an established and respected international partnership, we can do more than fund people with great ideas. We must push ourselves in our second decade to do more. We can use our focus on excellence, our experience, expertise and authority to influence the contexts in which ideas progress, and to make sure they can generate the maximum possible benefit for the largest number.",
    'COVID-19 Resource Hub': 'COVID-19 Resource Hub',
    'Recent Awards': 'Recent Awards',
    'Home': 'Home',
    "Applicant's Corner": "Applicant's Corner",
  //  "Fellow's Corner": "Fellow's Corner", 
    "Awardee’s Corner" : "Awardee’s Corner",
    'About': 'About',
    'More': 'More',
    "More Stories": "More Stories",
    'See All': 'See All',
    'View All': 'View All',
    "Pan India Reach": "Pan India Reach",
    "Our Impact": "Our Impact",
    "Clinical & Public Health Research Fellowships": "Clinical & Public Health Research Fellowships",
    'Competition Deadlines': 'Competition Deadlines',
    "Awardees": "Awardees",
    "Senior Fellowships": "Senior Fellowships",
    "Basic Biomedical Research Fellowships": "Basic Biomedical Research Fellowships",
    "Clinical & Public Health Fellowships": "Clinical & Public Health Fellowships",
    'Stories of Science': 'Stories of Science',
    "What People Say": "What People Say",
    "Forging Collaborations": "Forging Collaborations",
    "Programmes to build capacity in the biomedical and healthcare research ecosystem": "Programmes to build capacity in the biomedical and healthcare research ecosystem",
    "Building Capacity": "Building Capacity",
    "National and International collaborative relationships enabled": "National and International collaborative relationships enabled",
    "Events & Workshops": "Events & Workshops",
    'Number of awards India Alliance has provided to National & International Researchers': 'Number of awards India Alliance has provided to National & International Researchers',
    "AboutDesc": "DBT/Wellcome Trust India Alliance (India Alliance) is a strategic partnership between the Department of Biotechnology, Government of India and the Wellcome Trust, a global charitable foundation based in the UK, to promote and support biomedical research in India.",
    "Research Portfolio": "Research Portfolio"
  }
  currentLabelsObj: any = {}
  constructor(
    public _appservice: AppService,
    private router: Router,
    public domeSanitzer: DomSanitizer,
    private nzMessageService: NzMessageService,
  ) {
    this._appservice.onChangeLanguageEmitter.subscribe((data: any) => {
      this.onTranslate()
    })
  }
  ngOnInit(): void {
    this.currentLabelsObj = this.labelsObj
    this.cardWidth = `350px`;
    this.responsiveOptions = [
      {
        breakpoint: "1024px",
        numVisible: 3,
        numScroll: 3,
      },
      {
        breakpoint: "768px",
        numVisible: 2,
        numScroll: 2,
      },
      {
        breakpoint: "560px",
        numVisible: 1,
        numScroll: 1,
      },
    ];
    this.getFellowsList();
    this.getHomeSliders()
    this.getNewsList()
    this.getEventsList()
    this.getDeadLinesList()
    this.newsFeedData = [
      {
        image:
          "https://dbtindiaalliance.s3.ap-south-1.amazonaws.com/otxzfdzbjnyugdy1591556414274.png",
        newsHeadings:
          "Webinar on COVID-19: Ask The Experts - Part 8 I 8th June I 2 PM",
        date: "December 16, 2019",
        description:
          "Fear, worry, and stress are normal responses to perceived or real threats, more so during times when we are faced with imponderables. It is normal to be scared, worried or stressed in a pandemic, such as the ongoing COVID-19.",
      },
      {
        image:
          "https://dbtindiaalliance.s3.ap-south-1.amazonaws.com/otxzfdzbjnyugdy1591556414274.png",
        newsHeadings:
          "Webinar on COVID-19: Ask The Experts - Part 8 I 8th June I 2 PM",
        date: "December 16, 2019",
        description:
          "Fear, worry, and stress are normal responses to perceived or real threats, more so during times when we are faced with imponderables. It is normal to be scared, worried or stressed in a pandemic, such as the ongoing COVID-19.",
      },
      {
        image:
          "https://dbtindiaalliance.s3.ap-south-1.amazonaws.com/otxzfdzbjnyugdy1591556414274.png",
        newsHeadings:
          "Webinar on COVID-19: Ask The Experts - Part 8 I 8th June I 2 PM",
        date: "December 16, 2019",
        description:
          "Fear, worry, and stress are normal responses to perceived or real threats, more so during times when we are faced with imponderables. It is normal to be scared, worried or stressed in a pandemic, such as the ongoing COVID-19.",
      },
    ];
    setInterval(() => {
      this.changesBg(1)
    }, 5000);
    this.onTranslate()
  }
  onComments(item, i) {
    let thirdItem = this.comments[3]
    this.comments[3] = item
    this.comments[i] = thirdItem
    this.selectedComment = item
  }
  onChangeDirection(item, directionSide) {0
    if (directionSide == -1) {
      let previousArray = []
      previousArray = [...this.comments]
      console.log('previousArray', previousArray)
      this.comments[0] = previousArray[6]
      this.comments[1] = previousArray[0]
      this.comments[2] = previousArray[1]
      this.comments[3] = previousArray[2]
      this.comments[4] = previousArray[3]
      this.comments[5] = previousArray[4]
      this.comments[6] = previousArray[5]
      this.selectedComment = this.comments[3]
    } else {
      let previousArray = []
      previousArray = [...this.comments]
      this.comments[0] = previousArray[1]
      this.comments[1] = previousArray[2]
      this.comments[2] = previousArray[3]
      this.comments[3] = previousArray[4]
      this.comments[4] = previousArray[5]
      this.comments[5] = previousArray[6]
      this.comments[6] = previousArray[0]
      this.selectedComment = this.comments[3]
    }
  }
  onNavigate(event) {
    if (event) {
      event?.stopPropagation();
    }
    let findIndex = this.bgImages.findIndex(item => item.Document_Information.Document_URL == this.bgUrl)
    window.open(this.bgImages[findIndex].Item_URL, "_blank");
  }
  changesBg(type, event?) {
    if (event) {
      event?.stopPropagation();
    }
    console.log('chilsd')
    if (type == 1) {
      let findIndex = this.bgImages.findIndex(item => item.Document_Information.Document_URL == this.bgUrl)
      if (findIndex + 1 >= this.bgImages.length) {
        this.bgUrl = this.bgImages[0].Document_Information.Document_URL
        this.currentUrl = this.bgImages[0].Item_URL
      } else {
        this.bgUrl = this.bgImages[findIndex + 1].Document_Information.Document_URL
        this.currentUrl = this.bgImages[findIndex + 1].Item_URL
      }
    }
    else if (type == -1) {
      let findIndex = this.bgImages.findIndex(item => item.Document_Information.Document_URL == this.bgUrl)
      if (findIndex == 0) {
        this.bgUrl = this.bgImages[this.bgImages.length - 1].Document_Information.Document_URL
        this.currentUrl = this.bgImages[this.bgImages.length - 1].Item_URL
      } else {
        this.bgUrl = this.bgImages[0].Document_Information.Document_URL
        this.currentUrl = this.bgImages[0].Item_URL
      }
    }
  }
  newItemNavigate(item) {
    // this.router.navigate(['/news', item.Post_URL])
    this.router.navigate(['/stories_of_science', item.Post_URL])
  }
  getHomeSliders() {
    const body = {
      Random_Count: 3,
    };
    try {
      this._appservice
        .postMethod("Fetch_All_Home_Slider_Items", body)
        .subscribe(
          (resp) => {
            if (resp.success) {
              this.bgImages = resp.extras.Data;
              this.bgUrl = this.bgImages[0].Document_Information.Document_URL
              console.log('this.bgUrl', this.bgUrl)
              this.getImageDimenstion(this.bgUrl)
            } else {
            }
          },
          (resp: any) => {
            this.nzMessageService.error(resp.error.extras.msg);
          }
        );
    } catch (e) { }
  }

  // new change
  // getEventsList() {
  //   const body = {
  //     skip: 0,
  //     limit: 10,
  //     Whether_Status_Filter: true,
  //     Status: true,
  //     Whether_Search_Filter: false,
  //     Search_Input:"this.filterForm.get('Search_Input').value",
  //     Whether_Post_Type_Filter:true,
  //     // Post_Type:6,
  //     Whether_Date_Filter: false,
  //   };
  //   try {
  //     this._appservice
  //       // .postMethod("Filter_All_Posts", body)
  //       .postMethod("Fetch_All_Available_Events", body)
  //       .subscribe(
  //         (resp) => {
  //           if (resp.success) {
  //             this.TotalItems = resp.extras.Count;
  //             this.Eventdata = resp.extras.Data;
  //           } else {
  //           }
  //         },
  //         (resp: any) => {
  //           this.nzMessageService.error(resp.error.extras.msg);
  //         }
  //       );
  //   } catch (e) {}
  // }
  // --------------------------
  getNewsList() {
    const body = {
      // skip: 0,
      // limit: 5,
      // Whether_Status_Filter: true,
      Status: true,
      // Whether_Search_Filter: false,
      // Search_Input: this.filterForm.get('Search_Input').value,
      // Whether_Post_Type_Filter: false,
      // Post_Type: this.filterForm.get('Post_Type').value,
      // Whether_Date_Filter: false,
      Whether_home_post : true,
      // Start_Date: this.filterForm.get('dateRange').value.length > 0 ? this.filterForm.get('dateRange').value[0] : null,
      // End_Date: this.filterForm.get('dateRange').value.length > 0 ? this.filterForm.get('dateRange').value[1] : null,
    };
    try {
      this._appservice
        .postMethod("Filter_Home_Posts", body)
        .subscribe(
          (resp) => {
            if (resp.success) {
              this.homePageNews = resp.extras.Data;
              console.log("post",this.homePageNews)
              this.homePageNews.forEach(element => {
                this.labelsObj[element.Post_Title] = element.Post_Title
                this.labelsObj[element.Post_Description] = element.Post_Description
              });
              this.currentLabelsObj = this.labelsObj
            } else {
            }
          },
          (resp: any) => {
            this.nzMessageService.error(resp.error.extras.msg);
          }
        );
    } catch (e) { }
  }
  getFellowsList() {
    const body = {
      Random_Count: 3,
    };
    try {
      this._appservice
        .postMethod("Fetch_Random_Fellows", body)
        .subscribe(
          (resp) => {
            if (resp.success) {
              this.fellowsList = resp.extras.Data;
              this.fellowsList.forEach(element => {
                this.labelsObj[element.Name] = element.Name
                this.labelsObj[element.Fellowship_Type_Title] = element.Fellowship_Type_Title
              });
              this.currentLabelsObj = this.labelsObj
            } else {
            }
          },
          (resp: any) => {
            this.nzMessageService.error(resp.error.extras.msg);
          }
        );
    } catch (e) { }
  }
  
  getEventsList() {
    const body = {
      skip: 0,
      limit: 3,
      Whether_Status_Filter: true,
      Status: true,
      // Whether_Search_Filter: false,
      // Search_Input: " this.filterForm.get('Search_Input').value",
      // Whether_Post_Type_Filter: true,
      Post_Type: 6,
      // Whether_Date_Filter: false,
    };
    try {
      this._appservice
        .postMethod("Fetch_All_Home_Events", body)
        .subscribe(
          (resp) => {
            if (resp.success) {
              this.eventsList = resp.extras.Data;
            } else {
            }
          },
          (resp: any) => {
            this.nzMessageService.error(resp.error.extras.msg);
          }
        );
    } catch (e) { }
  }
// ----- new change
  eventItemNavigate(item) {
    this.router.navigate(['/event', item.Event_URL])
  }

  // -----
  getDeadLinesList() {
    const body = {
      skip: 0,
      limit: 3,
    };
    try {
      this._appservice
        .postMethod("Fetch_All_Application_Deadlines", body)
        .subscribe(
          (resp) => {
            if (resp.success) {
              this.deadLinesList = resp.extras.Data;
            } else {
            }
          },
          (resp: any) => {
            this.nzMessageService.error(resp.error.extras.msg);
          }
        );
    } catch (e) { }
  }
  onFellowDetail(item) {
    this.router.navigate(["fellow", item.Fellow_URL]);
  }
  onResize(event) {
    if (event.target.innerWidth >= 1366) {
      this.cardWidth = `350px`;
    }
    if (event.target.innerWidth < 768 || event.target.innerWidth < 1024) {
      this.cardWidth = `320px`;
    }
    if (event.target.innerWidth > 560 || event.target.innerWidth <= 768) {
      this.cardWidth = `320px`;
    }
    if (event.target.innerWidth <= 560) {
      this.cardWidth = `300px`;
    }
  }
  getImageDimenstion(imgUrl) {
    let img = new Image();
    img.src = imgUrl;
    img.onload = (event) => {
      let loadedImage: any;
      loadedImage = event.currentTarget;
      let width = loadedImage.width;
      let height = loadedImage.height;
      this.bannerHeight = loadedImage.height;
      console.log('this.bannerHeight', this.bannerHeight)
    }
  }
  onTranslate() {
    this.currentLabelsObj = this._appservice.onTranslate(this.labelsObj, this.currentLabelsObj)
  }
}
